import { withStyles } from '@material-ui/styles';
import { TableRow, TableCell, TableSortLabel } from '@material-ui/core';

export const PersonalizadaTableRow = withStyles((theme) => ({
    root: {
        backgroundColor: 'white',
        cursor: "pointer",
        '&:nth-of-type(odd)': {
            backgroundColor: '#F4F7F7',
        },
        "&:first-of-type td": {
            borderTop: "1px solid #ECEFF1",
            borderBottomWidth: "0",
        },
        "&+&": {
            "& > td": {
                borderTop: "1px solid #ECEFF1",
                borderBottomWidth: "0",
            },
        },
    },
}))(TableRow);

export const HeaderTableRow = withStyles((theme) => ({
    root: {
        borderBottomWidth: "0",
        borderRadius: '8px 8px 0px 0px',
        backgroundColor: 'white',
        "& th": {
            padding: "16px 0"
        }
    },
}))(TableRow);

export const CeldaPersonalizada = withStyles((theme) => ({
    head: {
        color: '#02599E',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '16px',
    },
    body: {
        textAlign: 'center',
        color: '#011328',
        fontWeight: '400',
        fontSize: '12px',
        height: '48px',
    },
}))(TableCell);

export const TableSortLabelPersonalizada = withStyles((theme) => ({
    root: {
        display: "block",
        position: "relative",
        color: "#02599E !important",
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "16px",
        textAlign: "center",
        "&:hover": {
            color: "#709FC5",
        },
    },
    active: {
        color: "#02599E !important",
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "16px",
        textAlign: "center",
        "&:hover": {
            color: "#709FC5",
        },
    },
    icon: {
        width: "15px",
        height: "14px",
        color: "#02599E !important",
        position: "absolute",
        float: "inline-end",
        marginRight: "0",
    },
}))(TableSortLabel);
